export default __webpack_public_path__ + "static/media/background.9ec781ac.png";